export function InfoIcon({ size = 35 }): React.JSX.Element {
  return (
    <svg
      fill="none"
      height={size}
      viewBox="0 0 35 35"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="17.5" cy="17.5" fill="black" opacity="0.7" r="17.5" />
      <circle cx="17.5003" cy="11.2893" fill="white" r="2.25806" />
      <rect
        fill="#D9D9D9"
        height="10.7258"
        width="4.51613"
        x="15.2422"
        y="15.8086"
      />
    </svg>
  );
}
